<template>
  <div>
    
    <section class="c-section c-section--game">
      <div class="o-container o-container--small">
        <main-header></main-header>

        <div class="c-instructions s-entry-content">
          <h3>How to play</h3>

          <p>Clear your mind of all distractions. That means stop eating too! It’s time to solve some riddles.</p>

          <p>To unlock the secrets of ikigai, you must tell me the correct 5-letter passcode and answer a final question correctly. Each letter of the passcode contains a scroll with 3 riddles. Their answers all begin with the letter that you must enter above the scroll.</p>

          <p>If you make an incorrect attempt, I will provide a hint to help.</p>

          <p>Good luck!</p>
        </div>
        
        <div class="c-answers" v-bind:class="{'c-answers--complete': stage > 4}">
          <div class="c-answers__wrap">
            <div class="c-answers__chest"></div>
            
            <div class="c-inari c-answers__inari" v-bind:class="{'c-inari--active': stage <= 4}">
              <div class="c-answers__bubble" v-bind:class="{'c-answers__bubble--animate': animateInari, 'c-answers__bubble--correct': recentlyCorrect, 'c-answers__bubble--incorrect': !recentlyCorrect}">
                <div v-if="!recentlyCorrect">Try Again!</div>
                <div v-if="recentlyCorrect">SUGOI! <span>(awesome!)</span></div>
              </div>
              <img :src="`${baseUrl}img/inari.svg`" alt="INARI">
            </div>

            <div class="c-answers__hint" v-bind:class="{'c-answers__hint--active': !recentlyCorrect}">{{ hints[stage] }}</div>

            <form class="c-answer-form" @click="gameOn">
              <div class="c-answer-form__item" v-for="(n, index) in 5" ref="formItem" v-bind:class="[answerStates[index], {'c-answer-form__item--active': stage === index && formActive}]">
                <div class="c-answer-form__icon"></div>
                <div class="c-anwer-form__answer">
                  <input class="riddle-input" type="text" v-on:input="update" maxlength="2" placeholder="?" v-model="answers[index]" :disabled="checkingAnswer || index < stage" @focus="gameOn" @blur="gameOff"/>
                  <span v-bind:class="{'c-answer--ready': answers[index] === ''}">{{ answers[index] ? answers[index] : '?' }}</span>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="c-riddles" ref="riddleSection" v-bind:class="{'c-riddles--active': formActive}" v-show="stage < 5">
          <div class="c-scroll c-scroll--large">
            <img class="c-scroll__top" :src="`${baseUrl}img/scroll/top.svg`" alt="">
            <div class="c-scroll__middle">
              <svg class="c-scroll__shadow c-scroll__shadow--top" width="532.4" height="81.16" preserveAspectRatio="xMinYMin meet" viewBox="0 0 532.4 81.16" role="presentation"><path fill="#cfa973" d="M532.4 0v43.72L0 81.16V0z"/></svg>

              <div class="c-riddles__content" ref="riddleContent">
                <header>
                  <h3>Scroll {{ stage + 1 }}</h3>
                  <p><strong>All answers begin with the letter you seek.</strong></p>
                </header>

                <ul class="c-riddles__list">
                  <li v-for="(riddle, index) in riddles[stage]">
                    <div class="c-riddles__icon">
                      <img :src="`${baseUrl}img/riddles/${riddle.img}`" :width="riddle.imgWidth" alt="">
                    </div>
                    <div class="c-riddles__text s-entry-content">
                      <p><strong>Riddle {{ index + 1 }}</strong></p>
                      <p>{{ riddle.text }}</p>
                    </div>
                  </li>
                </ul>
              </div>

              <svg class="c-scroll__shadow c-scroll__shadow--bottom" width="532.4" height="81.28" preserveAspectRatio="xMinYMax meet" viewBox="0 0 532.4 81.28" role="presentation"><path fill="#cfa973" d="M0 12.28L532.4 0v81.28H0z"/></svg>
            </div>
            <img class="c-scroll__bottom" :src="`${baseUrl}img/scroll/bottom.svg`" alt="">
          </div>
        </div>

        <final-riddle v-show="stage === 5"></final-riddle>
        <entry-form v-if="stage === 6"></entry-form>

      </div>
    </section>

  </div>
</template>

<script>
  import Icon from '@/components/Icon';
  import FinalRiddle from '@/components/FinalRiddle';
  import EntryForm from '@/components/EntryForm';
  import MainHeader from '@/components/MainHeader';

  export default {
    name: 'game',
    components: {
      Icon,
      EntryForm,
      FinalRiddle,
      MainHeader,
    },
    data() {
      return {
        formActive: false,
        recentlyCorrect: true,
        checkingAnswer: false,
        animateInari: false,
        inariAnim: null,
        inariText: [
          'SUGOI! <span>(awesome!)</span>',
          'Try Again!',
        ],
        answerStates: ['', '', '', '', ''],
        hints: [
          'Mount Fuj_',
          'Bullet Trai_',
          'R_men noodles',
          'Ai_ Asia',
          'Sush_',
        ],
        answers: ['', '', '', '', ''],
        cursor: 'left',
        showEntryForm: false,
        correctAnswers: ['I', 'N', 'A', 'R', 'I'],
        riddles: [
          [
            {
              img: '1-1.svg',
              imgWidth: 108,
              text: 'I am a shrine with a miracle on water - a ‘floating’ torii gate. I am a UNESCO World Heritage listed site.',
            },
            {
              img: '1-2.svg',
              imgWidth: 85,
              text: 'Prepare yourself for bowl after bowl of soba noodles. It’s Wanko soba time, which originated in this Japanese prefecture.',
            },
            {
              img: 'airasia.svg',
              imgWidth: 98,
              text: 'The top 3 busiest railway stations in the world are in Tokyo. They are 1) Shinjuku 2) Shibuya and 3) ?',
            },
          ],
          [
            {
              img: '2-1.svg',
              imgWidth: 100,
              text: 'From up here on Mount Inasa, I offer you one of the top 3 most spectacular night views in Japan. Which city am I?',
            },
            {
              img: '2-2.svg',
              imgWidth: 93,
              text: 'Things are about to get even hotter in ‘Hell Valley’ with this famous onsen in Hokkaido.',
            },
            {
              img: 'airasia.svg',
              imgWidth: 98,
              text: 'I’m an entertainment district and major city centre located in southern Osaka.',
            },
          ],
          [
            {
              img: '3-1.svg',
              imgWidth: 92,
              text: 'Put on your dancing shoes, it’s time for Japan’s largest dance festival in Tokushima prefecture on the island of Shikoku.',
            },
            {
              img: '3-2.svg',
              imgWidth: 88,
              text: 'I am an island in Ehime prefecture inhabited by more cats than humans.',
            },
            {
              img: 'airasia.svg',
              imgWidth: 98,
              text: 'I am a prefecture in Tohoku famous for apples and the famous Nebuta Festival.',
            },
          ],
          [
            {
              img: '4-1.svg',
              imgWidth: 109,
              text: 'I am a traditional Japanese-style inn usually found near onsen (hot springs).',
            },
            {
              img: '4-2.svg',
              imgWidth: 83,
              text: 'I belong to an indigenous group that resides in Okinawa. Our language, food and arts are distinctly different from the rest of Japan. What am I?',
            },
            {
              img: 'airasia.svg',
              imgWidth: 98,
              text: 'I am a hearty bowl of egg noodles, often served in a broth made of pork-bone, soy, salt or miso.',
            },
          ],
          [
            {
              img: '5-1.svg',
              imgWidth: 101,
              text: 'Warm your soul in Hokkaido with this local speciality hot pot dish that features salmon as its star ingredient.',
            },
            {
              img: '5-2.svg',
              imgWidth: 87,
              text: 'I am a Japanese-style informal pub where people come to eat, drink and unwind.',
            },
            {
              img: 'airasia.svg',
              imgWidth: 98,
              text: 'I am Okinawa’s 3rd largest island, home to the sparkling blue waters of Kabira Bay.',
            },
          ],
        ],
        inititalInit: false,
        ctrlDown: false,
      };
    },
    computed: {
      stage: {
        get() { return this.$store.state.stage; },
        set(value) { this.$store.commit('setStage', value); },
      },
    },
    methods: {
      gameOn() {
        if (this.stage > 4) return;
        this.formActive = true;
        this.$refs.formItem[this.stage].getElementsByTagName('input')[0].focus();
        if (!this.inititalInit) {
          this.$ga.event('SecretScrolls', 'Click', `Field ${this.stage + 1}`);
          this.inititalInit = true;
        }
        this.expandRiddleSection();
      },
      gameOff() {
        if (this.stage > 4) return;
        if (this.checkingAnswer) return;
        this.formActive = false;
        this.$refs.formItem[this.stage].getElementsByTagName('input')[0].blur();
        this.collapseRiddleSection();
      },
      update(e) {
        e.preventDefault();
        const val = e.target.value.charAt(e.target.value.length - 1).toUpperCase();
        const inputEl = e.target;
        inputEl.value = val.charAt(0);
        if (this.checkingAnswer) return;
        if (val.length === 0) {
          this.$set(this.answerStates, this.stage, '');
          return;
        }
        this.checkingAnswer = true;
        const currentStage = this.stage;
        this.answers[this.stage] = val.charAt(0);
        this.$set(this.answerStates, this.stage, 'c-answer-form__item--loading');
        setTimeout(() => {
          if (this.answers[this.stage] === this.correctAnswers[this.stage]) {
            this.$set(this.answerStates, this.stage, 'c-answer-form__item--correct');
            this.recentlyCorrect = true;
            this.collapseRiddleSection();
            if (this.stage >= 4) this.initFinalAnswer();
            else setTimeout(() => this.nextRiddle(), 500);
          } else {
            this.recentlyCorrect = false;
            this.$set(this.answerStates, this.stage, 'c-answer-form__item--incorrect');
          }
          if (this.answers[currentStage] !== '') {
            this.animateInari = true;
            clearTimeout(this.inariAnim);
            this.inariAnim = setTimeout(() => { this.animateInari = false; }, 3000);
          }
          if (!this.recentlyCorrect) {
            this.checkingAnswer = false;
            this.$nextTick(() => {
              this.$refs.formItem[this.stage].getElementsByTagName('input')[0].focus();
            });
          }
        }, 1000);
      },
      nextRiddle() {
        this.stage = this.stage + 1;
        this.$ga.event('SecretScrolls', 'Click', `Field ${this.stage + 1}`);
        // this.$store.commit('setStage', this.stage + 1);
        this.checkingAnswer = false;
        this.expandRiddleSection();
        this.$nextTick(() => {
          this.$refs.formItem[this.stage].getElementsByTagName('input')[0].focus();
        });
      },
      initFinalAnswer() {
        this.$ga.event('SecretScrolls', 'Click', 'Field 6 Wildcard');
        this.$store.commit('setStage', 5);
        this.formActive = false;
        // this.$refs.finalRiddle.getElementsByTagName('input')[0].focus();
      },
      expandRiddleSection() {
        this.$nextTick(() => {
          const element = this.$refs.riddleContent;
          const sectionHeight = element.scrollHeight;
          requestAnimationFrame(() => {
            element.style.height = `${sectionHeight}px`;
          });
        });
      },
      collapseRiddleSection() {
        requestAnimationFrame(() => {
          this.$refs.riddleContent.style.height = 0;
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Game.vue?d29b39ee